<template>
    <div class="container">
        Du har tilgang til alle wrike Brukere. Menyen vises ovenfor.
    </div>
</template>
<script>
    export default {
        name: "Users"
    }
</script>